/* eslint-disable */
import Vue from 'vue';
import vueCustomElement from 'vue-custom-element';
import { i18n } from '@/plugins/i18n';
import store from '@/store';
import globalMixin from '@/mixins/global';
import { debounce, cloneDeep } from '@/helpers/utilities';
import setup from '@/helpers/setup';
import highlightText from '@/directives/highlightText.directive';

Vue.config.productionTip = process.env.NODE_ENV === 'production';
Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.config.debug = process.env.NODE_ENV !== 'production';
Vue.config.silent = process.env.NODE_ENV !== 'production';

Vue.use(vueCustomElement);
Vue.directive('highlight-text', highlightText);
Vue.mixin(globalMixin);

/**
 * Create a global state for other apps to access.
 * @param {string} element - The elements tag.
 */
const createWindowState = (element) => {
  if (window.ndc && window.ndc.state) return;
  const $store = document.querySelector(element).getVueInstance().$store;
  window.ndc = window.ndc || {};
  window.ndc.state = cloneDeep($store.state);

  $store.subscribe(debounce(() => {
    window.ndc.state = cloneDeep($store.state);
  }, 50));
};

const options = {
  // shadow: true,
  vueInstanceCreatedCallback() {
    const message = { event: 'vue-created', element: this.tagName };
    createWindowState(this.tagName);
    window.postMessage(JSON.stringify(message), '*');
  },
  connectedCallback() {
    const message = { event: 'connected', element: this.tagName };
    window.postMessage(JSON.stringify(message), '*');
  },
  beforeCreateVueInstance(RootComponentDefinition) {
    const object = {
      ...RootComponentDefinition,
    };

    object.store = store;
    object.i18n = i18n;

    setup.created();

    return object;
  },
  props: ['data', 'name'],
};

Vue.customElement(
  'nd-component',
  () =>
    new Promise(resolve =>
      import(
        /* webpackChunkName: "CustomElement" */ './components/CustomElement.vue'
      ).then(module => resolve(module.default)),
    ),
  options,
);
